import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'
import { ILanguage } from 'static/languages'

const registerByTelegram = (data: {
  visitorId: string
  language?: ILanguage['locale']
  preferredCurrency: number
  initData: string
  companyId?: string | null
  countryCode?: string | null
  offer?: string | null
  partnerId?: string | null
  subid3?: string
}): AxiosPromise => apiFetch(`/telegram-auth/register`, { data, method: `POST` })

export default registerByTelegram
